// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.planManagementContainer {
  /* padding: 20px; */
  max-width: 800px;
  margin: 0 !important;
  padding: 0 !important;
}

/* 다른 페이지와 동일한 제목 스타일 사용 */
.pageTitle {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px !important;
}

.planInfoSection {
  margin-bottom: 40px;
}

.planStatus {
  font-size: 18px;
  margin-bottom: 20px;
}

.planName {
  font-size: 24px !important;
  font-weight: bold;
}

.planExpiry {
  color: #ff6b00; /* 메인 오렌지 색상 */
}

.daysLeft {
  color: #ff6b00; /* 메인 오렌지 색상 */
  font-weight: bold;
}

/* 버튼 컨테이너로 위치 정렬 */
.buttonContainer {
  margin-top: 20px;
  width: 100%;
  max-width: 400px; /* 너비 제한 */
}

/* PlanUpgrade의 버튼 스타일 가져오기 */
.subscribeButton {
  padding: 15px;
  width: 100%; /* 컨테이너 너비에 맞춤 */
  max-width: 350px; /* 최대 너비 설정 */
  height: 80px;
  border: none;
  border-radius: 5px;
  background: rgba(255, 94, 7, 0.15);
  color: black;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
  font-weight: bold;
  transition: background 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.subscribeButton:hover {
  background: rgba(255, 94, 7, 0.25);
}

.buttonPrefix {
  font-size: 12px;
  margin-bottom: 5px;
  font-weight: normal;
}

.buttonText {
  font-weight: bold;
}

.smallText {
  font-size: 12px;
  color: #333;
  margin-bottom: 5px;
}

.companyCodeSection {
  margin-top: -70px !important;
  max-width: 400px; /* 구독 버튼과 동일한 너비 제한 */
}

.sectionTitle {
  font-size: 20px;
  margin-bottom: 20px;
}

/* 회사코드 제목 굵게 표시 */
.boldText {
  font-weight: bold;
}

/* 회사코드 스타일 변경 */
.codeDisplayBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(255, 94, 7, 0.15); /* 구독하기 버튼과 동일한 배경색 */
  border-radius: 5px; /* 구독하기 버튼과 동일한 모서리 둥글기 */
  padding: 0 16px;
  width: 100%; /* 컨테이너 너비에 맞춤 */
  max-width: 350px; /* 구독버튼과 동일한 최대 너비 */
  height: 40px; /* 요청한 높이 */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: none;
}

.codeValue {
  font-family: monospace;
  font-size: 16px;
  letter-spacing: 1px;
  color: #333;
}

.viewCodeButton {
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.eyeIcon {
  color: #333;
  width: 24px;
  height: 24px;
}

.viewCodeButton:hover .eyeIcon {
  color: #FF6B00; /* 메인 색상으로 변경 */
}

/* 눈 아이콘에 사용할 강조색 (녹색) */
.viewCodeButton:active .eyeIcon {
  color: #00FF00;
}

/* 에러 메시지 스타일 */
.errorMessage {
  background-color: #ffebee;
  color: #c62828;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 20px;
  text-align: center;
}

.retryButton {
  background-color: #ff6b00;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  font-weight: bold;
  margin: 0 auto;
  display: block;
} `, "",{"version":3,"sources":["webpack://./src/styles/PlanManagement.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,cAAc,EAAE,cAAc;AAChC;;AAEA;EACE,cAAc,EAAE,cAAc;EAC9B,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB,EAAE,UAAU;AAC9B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,WAAW,EAAE,gBAAgB;EAC7B,gBAAgB,EAAE,aAAa;EAC/B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB,EAAE,qBAAqB;AACzC;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wCAAwC,EAAE,qBAAqB;EAC/D,kBAAkB,EAAE,yBAAyB;EAC7C,eAAe;EACf,WAAW,EAAE,gBAAgB;EAC7B,gBAAgB,EAAE,oBAAoB;EACtC,YAAY,EAAE,WAAW;EACzB,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc,EAAE,eAAe;AACjC;;AAEA,wBAAwB;AACxB;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB","sourcesContent":[".planManagementContainer {\n  /* padding: 20px; */\n  max-width: 800px;\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n/* 다른 페이지와 동일한 제목 스타일 사용 */\n.pageTitle {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 20px !important;\n}\n\n.planInfoSection {\n  margin-bottom: 40px;\n}\n\n.planStatus {\n  font-size: 18px;\n  margin-bottom: 20px;\n}\n\n.planName {\n  font-size: 24px !important;\n  font-weight: bold;\n}\n\n.planExpiry {\n  color: #ff6b00; /* 메인 오렌지 색상 */\n}\n\n.daysLeft {\n  color: #ff6b00; /* 메인 오렌지 색상 */\n  font-weight: bold;\n}\n\n/* 버튼 컨테이너로 위치 정렬 */\n.buttonContainer {\n  margin-top: 20px;\n  width: 100%;\n  max-width: 400px; /* 너비 제한 */\n}\n\n/* PlanUpgrade의 버튼 스타일 가져오기 */\n.subscribeButton {\n  padding: 15px;\n  width: 100%; /* 컨테이너 너비에 맞춤 */\n  max-width: 350px; /* 최대 너비 설정 */\n  height: 80px;\n  border: none;\n  border-radius: 5px;\n  background: rgba(255, 94, 7, 0.15);\n  color: black;\n  font-size: 16px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-top: 5px;\n  font-weight: bold;\n  transition: background 0.3s ease;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.subscribeButton:hover {\n  background: rgba(255, 94, 7, 0.25);\n}\n\n.buttonPrefix {\n  font-size: 12px;\n  margin-bottom: 5px;\n  font-weight: normal;\n}\n\n.buttonText {\n  font-weight: bold;\n}\n\n.smallText {\n  font-size: 12px;\n  color: #333;\n  margin-bottom: 5px;\n}\n\n.companyCodeSection {\n  margin-top: -70px !important;\n  max-width: 400px; /* 구독 버튼과 동일한 너비 제한 */\n}\n\n.sectionTitle {\n  font-size: 20px;\n  margin-bottom: 20px;\n}\n\n/* 회사코드 제목 굵게 표시 */\n.boldText {\n  font-weight: bold;\n}\n\n/* 회사코드 스타일 변경 */\n.codeDisplayBox {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: rgba(255, 94, 7, 0.15); /* 구독하기 버튼과 동일한 배경색 */\n  border-radius: 5px; /* 구독하기 버튼과 동일한 모서리 둥글기 */\n  padding: 0 16px;\n  width: 100%; /* 컨테이너 너비에 맞춤 */\n  max-width: 350px; /* 구독버튼과 동일한 최대 너비 */\n  height: 40px; /* 요청한 높이 */\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border: none;\n}\n\n.codeValue {\n  font-family: monospace;\n  font-size: 16px;\n  letter-spacing: 1px;\n  color: #333;\n}\n\n.viewCodeButton {\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.eyeIcon {\n  color: #333;\n  width: 24px;\n  height: 24px;\n}\n\n.viewCodeButton:hover .eyeIcon {\n  color: #FF6B00; /* 메인 색상으로 변경 */\n}\n\n/* 눈 아이콘에 사용할 강조색 (녹색) */\n.viewCodeButton:active .eyeIcon {\n  color: #00FF00;\n}\n\n/* 에러 메시지 스타일 */\n.errorMessage {\n  background-color: #ffebee;\n  color: #c62828;\n  padding: 12px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.retryButton {\n  background-color: #ff6b00;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 16px;\n  cursor: pointer;\n  font-weight: bold;\n  margin: 0 auto;\n  display: block;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
